import { Put } from '../helpers';
import { Channel } from '@/types/channel.types';

export function UpdateChannel(channel: Channel): Promise<Channel> {
  return Put({ url: '/v3/admin/auth/update-channel', body: { channel } });
}
